
import Badge from "../../components/Badge.vue";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  components: { Badge },
  data() {
    return {
      mediaURL: this.$config.BASE_URL_RESOURCE,
      videoOptions: {
        controls: true,
        sources: [
          {
            src: "/videos/video.mp4",
            type: "video/mp4",
          },
        ],
      },
      data: {
        is_video: true,
        title: "",
        video: [
          {
            title: "",
            thumb: "",
            path: "",
            n_index: "",
            is_selected: "",
            created_at: "",
          },
        ],
        banner: "",
      },
    };
  },

  mounted() {
    const value = this.$store.state.SchoolDetail.school_outstanding;
    if (value) {
      if (!value.is_video) {
        this.data.is_video = false;
        this.data.banner = value.banner;
      } else {
        if (
          value.video &&
          Array.isArray(value.video) &&
          value.video.length > 0
        ) {
          const isSelectedIndex = value.video.findIndex(
            (item) => item.is_selected == 1
          );
          this.data.video = value.video;

          if (isSelectedIndex !== -1) {
            console.log(`${this.mediaURL}${value.video[0].path}`)
            this.videoOptions.sources[0].src = `${this.mediaURL}${value.video[0].path}`;
            // this.data.title = value.video[isSelectedIndex].title;
          } else {
            console.log(`${this.mediaURL}${value.video[isSelectedIndex].path}`)
            this.videoOptions.sources[0].src = `${this.mediaURL}${value.video[isSelectedIndex].path}`;
            // this.data.title = value.video[0].title;
          }
          // Video
          const nuxtInstance = this;

          this.player = videojs(
            this.$refs.videoPlayer,
            this.videoOptions,
            () => {
              var button = videojs.getComponent("Button");

              var nextButton = videojs.extend(button, {
                constructor: function () {
                  button.apply(this, arguments);
                  this.controlText("Next Course");
                  this.addClass("vjs-icon-next-item");
                  this.addClass("custom-button-video");
                },
                handleClick: function () {
                  this.player().dispose();
                },
              });

              var prevButton = videojs.extend(button, {
                constructor: function () {
                  button.apply(this, arguments);
                  this.controlText("Next Course");
                  this.addClass("vjs-icon-previous-item");
                  this.addClass("custom-button-video");
                },
                handleClick: function () {
                  this.player().dispose();
                },
              });

              // videojs.registerComponent("nextButton", nextButton);
              // videojs.registerComponent("prevButton", prevButton);
              // this.player.controlBar.addChild("prevButton", {}, 0);
              // this.player.controlBar.addChild("nextButton", {}, 2);
            }
          );
          this.player.poster(`${this.mediaURL}${this.data.video[0].thumb}`);

          var video = document.createElement("video");
          // video.setAttribute("src", this.videoOptions.sources[0].src);
          if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            video.muted = true;
            video.play();
            video.addEventListener(
              "loadeddata",
              function () {
                const width = video.videoWidth;
                const height = video.videoHeight;
                const ratio = width / height;
                const videoElement = nuxtInstance.$refs.videoPlayerWrapper;
                const elementWidth = videoElement.clientWidth;
                videoElement.style.height = `${elementWidth / ratio}px`;
                // videoElement.style.height = `${1000}}px`;
              },
              false
            );
          } else {
            this.$refs.videoPlayer.addEventListener(
              "loadedmetadata",
              function (e) {
                const videoElement = nuxtInstance.$refs.videoPlayerWrapper;
                videoElement.style.height = `${516}px`;
              },
              false
            );
          }
        }
      }
    }
    // const nuxtInstance = this;
    // console.log(this.$refs.videoPlayer);
    // this.player = videojs(this.$refs.videoPlayer, this.videoOptions, () => {
    //   this.player.log("onPlayerReady", this);
    //   var button = videojs.getComponent("Button");
    //   var nextButton = videojs.extend(button, {
    //     constructor: function () {
    //       button.apply(this, arguments);
    //       this.controlText("Next Course");
    //       this.addClass("vjs-icon-next-item");
    //       this.addClass("custom-button-video");
    //     },
    //     handleClick: function () {
    //       this.player().dispose();
    //     },
    //   });
    //   var prevButton = videojs.extend(button, {
    //     constructor: function () {
    //       button.apply(this, arguments);
    //       this.controlText("Next Course");
    //       this.addClass("vjs-icon-previous-item");
    //       this.addClass("custom-button-video");
    //     },
    //     handleClick: function () {
    //       this.player().dispose();
    //     },
    //   });
    //   videojs.registerComponent("nextButton", nextButton);
    //   videojs.registerComponent("prevButton", prevButton);
    //   this.player.controlBar.addChild("prevButton", {}, 0);
    //   this.player.controlBar.addChild("nextButton", {}, 2);
    // });
    // var video = document.createElement("video");
    // // video.setAttribute("src", this.videoOptions.sources[0].src);
    // if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    //   video.muted = true;
    //   video.play();
    //   video.addEventListener(
    //     "loadeddata",
    //     function () {
    //       const width = video.videoWidth;
    //       const height = video.videoHeight;
    //       const ratio = width / height;
    //       const videoElement = nuxtInstance.$refs.videoPlayerWrapper;
    //       const elementWidth = videoElement.clientWidth;
    //       videoElement.style.height = `${elementWidth / ratio}px`;
    //     },
    //     false
    //   );
    // } else {
    //   this.$refs.videoPlayer.addEventListener(
    //     "loadedmetadata",
    //     function (e) {
    //       const width = this.videoWidth;
    //       const height = this.videoHeight;
    //       const ratio = width / height;
    //       const videoElement = nuxtInstance.$refs.videoPlayerWrapper;
    //       const elementWidth = videoElement.clientWidth;
    //       videoElement.style.height = `${elementWidth / ratio}px`;
    //     },
    //     false
    //   );
    // }
  },
};
